<template>
    <ui-container class="py-8 space-y-8" :key="routePlanKey" v-if="routePlan">
        <!-- Header. -->
        <ui-header :title="`Route Plan ${routePlan.formattedDate}`" :subtitle="' '">
        </ui-header>
        <ui-data-grid>
            <ui-data-grid-item wide label="Route Plan ID" :value="'#'+routePlan.id"></ui-data-grid-item>
            <ui-data-grid-item label="Vehicle Registration" raw
                               :value="highlight(routePlan.vehicleRegistration)"></ui-data-grid-item>
            <ui-data-grid-item label="Driver" raw :value="highlight(routePlan.driver)"></ui-data-grid-item>
        </ui-data-grid>
        <div class="space-y-0">
            <label class="py-0">Jobs</label>
            <div
                class="flex mt-8 border-t border-b border-r border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold"
                v-if="!singleColumn">
                <div class="flex-1 border-l border-r border-gray-200 px-2 py-1">Address</div>
                <div class="flex-1 border-r border-gray-200 px-2 py-1">Contact</div>
                <div class="flex-1 border-r border-gray-200 px-2 py-1">Materials</div>
                <div class="w-6 flex-shrink-0 ml-2 pl-px"></div>
            </div>
            <template v-for="job in routePlan.jobs">
                <div class="flex border-collapse border-b border-r border-gray-200" :class="backgroundColor(job)+(singleColumn?' border-t':'')">
                    <template v-if="!singleColumn">
                        <div class="flex-1 border-l border-r border-gray-200 px-0 py-0">
                            <div class="text-sm px-2 py-1" style="white-space: pre-wrap"
                                 v-html="job.address ? highlight(job.address) : '&nbsp;'"></div>
                        </div>
                        <div class="flex-1 border-r border-gray-200 px-0 py-0">
                            <div class="text-sm px-2 py-1" style="white-space: pre-wrap"
                                 v-html="job.contact ? highlight(job.contact) : '&nbsp;'"></div>
                        </div>
                        <div class="flex-1 border-r border-gray-200 px-0 py-0">
                            <div class="text-sm px-2 py-1" style="white-space: pre-wrap"
                                 v-html="job.materials ? highlight(job.materials) : '&nbsp;'"></div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="flex-1 border-l border-r border-gray-200 px-0 py-0">
                            <div class="w-full px-0 py-0">
                                <div
                                    class="border-gray-200 bg-gray-50 border-b text-xs text-gray-500 font-semibold py-1 px-2">
                                    Address
                                </div>
                                <div class="text-sm px-2 py-1" style="white-space: pre-wrap"
                                     v-html="job.address ? highlight(job.address) : '&nbsp;'"></div>
                            </div>
                            <div class="w-full px-0 py-0">
                                <div
                                    class="border-gray-200 bg-gray-50 border-t border-b text-xs text-gray-500 font-semibold py-1 px-2">
                                    Contact
                                </div>
                                <div class="text-sm px-2 py-1" style="white-space: pre-wrap"
                                     v-html="job.contact ? highlight(job.contact) : '&nbsp;'"></div>
                            </div>
                            <div class="w-full px-0 py-0">
                                <div
                                    class="border-gray-200 bg-gray-50 border-t border-b text-xs text-gray-500 font-semibold py-1 px-2">
                                    Materials
                                </div>
                                <div class="text-sm px-2 py-1" style="white-space: pre-wrap"
                                     v-html="job.materials ? highlight(job.materials) : '&nbsp;'"></div>
                            </div>
                        </div>
                    </template>
                    <div class="w-6 flex-shrink-0 ml-2 self-start py-1.5">
                        <ui-dropdown menu-class="p-3 w-56">
                            <template #default="{ toggle }">
                                <button @click="toggle"
                                        class="w-5 h-5 flex routePlans-center justify-center text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 relative rounded">
                                    <i class="fa fa-ellipsis-h fa-fw"></i>
                                </button>
                            </template>
                            <template #menu="{ close }">
                                <template>
                                    <ui-dropdown-item icon="fas fa-undo" @click="resetJob(job);close();"
                                                      v-if="routePlan.isInPast() && (job.status!=='Awaiting')">Un-Mark
                                        Job
                                    </ui-dropdown-item>
                                    <ui-dropdown-item icon="fas fa-check" success @click="completeJob(job);close();"
                                                      v-if="routePlan.isInPast() && (job.status==='Awaiting')">Mark as
                                        Complete
                                    </ui-dropdown-item>
                                    <ui-dropdown-item icon="fas fa-times" danger @click="failJob(job);close();"
                                                      v-if="routePlan.isInPast() && (job.status==='Awaiting')">Unable to
                                        Complete
                                    </ui-dropdown-item>
                                </template>
                            </template>
                        </ui-dropdown>
                    </div>
                </div>
                <div class="w-full h-4" v-if="singleColumn"></div>
            </template>
        </div>

    </ui-container>
</template>

<script>
import RoutePlansJobItem from "../RoutePlansJobItem.vue";
import AutoresizableTextarea from "../../../ui/AutoresizableTextarea";
import UiContainer from "../../../ui/UiContainer.vue";
import {ExternalRoutePlan} from '@models'
import UiDropdownItem from "../../../ui/UiDropdownItem.vue";
import UiDropdown from "../../../ui/UiDropdown.vue";
import UiButtonNew from "../../../ui/UiButtonNew.vue";
import UiDataGrid from "../../../ui/UiDataGrid.vue";
import UiDataGridItem from "../../../ui/UiDataGridItem.vue";
import {cloneDeep, isNull} from "lodash";
import User from "../../../../services/User";
import UiHeader from "../../../ui/UiHeader.vue";

export default {
    components: {
        UiHeader,
        UiDataGridItem,
        UiDataGrid,
        UiButtonNew, UiDropdown, UiDropdownItem, UiContainer, AutoresizableTextarea, RoutePlansJobItem
    },
    props: {
        id: null | String,
    },
    computed: {},
    data() {
        return {
            routePlanKey: 0,
            routePlan: null,
            singleColumn: false,
        }
    },
    methods: {
        highlight(string) {
            return string
        },
        isNull,
        completeJob(job) {
            this.routePlan.completeJob(job);
        },
        failJob(job) {
            this.routePlan.failJob(job);
        },
        resetJob(job) {
            this.routePlan.resetJob(job);
        },
        backgroundColor(job) {
            if (job.status === 'Complete') {
                return 'bg-green-50';
            }
            if (job.status === 'Unable to Complete') {
                return 'bg-red-50';
            }
            return 'bg-white';
        },
        resizeHandler() {
            if ((this.$el.clientWidth < 800) && !this.singleColumn) {
                this.singleColumn = true;
                this.$forceUpdate();
            } else if ((this.$el.clientWidth > 800) && this.singleColumn) {
                this.singleColumn = false;
                this.$forceUpdate();
            }
        }
    },
    async mounted() {
        window.addEventListener('resize', this.resizeHandler)
        if (this.id) {
            this.routePlan = await ExternalRoutePlan.find(this.id);
        }
        this.$nextTick(() => this.resizeHandler())
    },
}
</script>
'